:host {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  overflow: hidden;
  width: 100%;
  background-color: $xp-ref-color-brand-primary;
  color: $xp-ref-color-brand-on-primary-brand;
  top: 0;
  z-index: 5;
  @include mobile {
    height: 60px;
    padding: 16px;
  }
  @include tablet {
    height: $xp-ref-size-12;
    padding: 0 $xp-ref-spacing-7;
  }
  @include desktop {
    height: $xp-ref-size-12;
    padding: 0 $xp-ref-spacing-7;
  }
}

.menu-items {
  display: flex;
  gap: $xp-ref-spacing-7;
  align-items: center;
  .about {
    font: $xp-ref-font-label-label-short;
    color: $xp-ref-color-brand-on-primary-brand;
    cursor: pointer;
  }
  .help {
    font-size: 24px;
    cursor: pointer;
  }

  @include mobile {
    .help {
      display: block;
    }
    .about {
      display: none;
    }
  }

  @include tablet {
    .help {
      display: none;
    }
    .about {
      display: block;
    }
  }

  @include desktop {
    .help {
      display: none;
    }
    .about {
      display: block;
    }
  }

  .shopping-cart {
    position: relative;
    .material-icons-sharp {
      color: $xp-ref-color-brand-on-primary-brand;
      font-size: 24px;
      cursor: pointer;
    }

    .counter {
      position: absolute;
      top: 14px;
      left: 20px;
      height: 14px;
      width: 14px;
      background-color: $xp-ref-color-state-select;
      cursor: pointer;
      overflow: hidden;

      .center {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font: $xp-ref-font-paragraph-paragraph-small;
        color: $xp-ref-color-text-default-dark;
      }
    }
  }
}

.logo {
  cursor: pointer;
  @include mobile {
    height: 30px;
  }
  @include tablet {
    height: 40px;
  }
  @include desktop {
    height: 45px;
  }
  object-fit: contain;
}

h4{
  color: $xp-ref-color-brand-on-primary-brand;
}

.title-container {
  @include mobile {
    visibility: hidden;
  }
  @include tablet {
    visibility: visible;
  }
  @include desktop {
    visibility: visible;
  }
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
}

.cart-view {
  position: fixed;
  width: max-content;

  @include mobile {
    right: 10px;
    top: 44px;
  }
  @include tablet {
    right: 25px;
    top: 52px;
  }
  @include desktop {
    right: 25px;
    top: 52px;
  }
}
